import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@stockaid/core';
import { RepricingItem } from 'src/app/core/utils/recommendation.utils';

@Component({
  selector: 'app-asc-repricing-formula',
  templateUrl: './asc-repricing-formula.component.html',
  styleUrls: ['./asc-repricing-formula.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AscRepricingFormulaComponent extends BaseComponent {
  @Input() repricingItem!: RepricingItem;
  @Input() isWrap = false;

  constructor() {
    super();
  }
}
